import {
  BookingState
} from '@/AppRedux/actions/booking/bookingType';
import { Rate, RoomData } from '@/AppRedux/actions/booking/bookingApiType';
import * as actions from '@/AppRedux/actions/booking/bookingType';

function computeNights(a?: string|null, b?: string|null) {
  
  if(a==="null" || b ==="null") return

  const A = new Date(a as string).getTime(), B = new Date(b as string).getTime();
  const ONE = 24*60*60*1000;
  return Math.max(1, Math.round((B-A)/ONE));
}

const buildCartKey = (room: RoomData, rate: Rate) =>
  `${room.roomtype_id}-${rate.rate_id}`;

const initialState: BookingState = {
  search: { checkIn: null, checkOut: null, adults: 2, children: 0, infants: 0, guestTouched: false, lastPropCode: null },
  availableRooms: [],
  cart: [],
  guestInfo: null,
  couponCode: '',
  discountAmount: 0,
  bookingRef: null,
  bookingStatus: null,
  loading: false,
  error: null,
};

export default function bookingReducer(
  state: BookingState = initialState,
  action: actions.BookingAction,
): BookingState {
  switch (action.type) {
    case actions.BOOKING_SEARCH:
      return { ...state, search: { ...state.search, ...action.payload } };
    case actions.BOOKING_AVAILABILITY_REQUEST:
      return { ...state, loading: true, error: null };
    case actions.BOOKING_SET_AVAILABILITY:
      return { ...state, loading: false, availableRooms:action.payload };
    case actions.BOOKING_AVAILABILITY_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case actions.BOOKING_UPSERT_QTY: {
      const { room, rate, qty } = action.payload;
      const nights = computeNights(state.search.checkIn, state.search.checkOut) || 1;

      const targetKey = buildCartKey(room, rate);
      const otherQty = state.cart.reduce(
        (sum, i) =>
          i.room.roomtype_id === room.roomtype_id && (i.cartKey || buildCartKey(i.room, i.rate)) !== targetKey
            ? sum + i.qty
            : sum,
        0,
      );
      const remaining = Math.max(0, (room.room_avail || 0) - otherQty);
      const clamped = Math.max(0, Math.min(remaining, qty | 0));
      const existing = state.cart.find(
        (i) => (i.cartKey || buildCartKey(i.room, i.rate)) === targetKey,
      );

      let cart = [...state.cart];
      if (clamped === 0) {
        cart = cart.filter((i) => (i.cartKey || buildCartKey(i.room, i.rate)) !== targetKey);
      } else if (existing) {
        const subtotal = clamped * existing.rate.room_rate * nights;
        cart = cart.map((i) =>
          (i.cartKey || buildCartKey(i.room, i.rate)) === targetKey
            ? { ...i, qty: clamped, nights, subtotal, cartKey: targetKey }
            : i,
        );
      } else {
        const subtotal = clamped * rate.room_rate * nights;
        cart.push({ cartKey: targetKey, room, rate, qty: clamped, nights, subtotal });
      }
      return { ...state, cart };
    }
    case actions.BOOKING_RESET_CART:
      return { ...state, cart: [] };
    case actions.BOOKING_APPLY_COUPON_REQUEST:
      return {...state}
    case actions.BOOKING_APPLY_COUPON_SUCCESS:
      return {
        ...state,
        loading: false,
        couponCode: action.payload.code,
        discountAmount: action.payload.discountAmount,
      };
    case actions.BOOKING_CLEAR_REQUEST:
      return {...state, loading:false , error:null,bookingRef:null}
    case actions.BOOKING_CREATE_REQUEST:
      return { ...state, loading: true, error: null };
    case actions.BOOKING_CREATE_SUCCESS:
      return { ...state, loading: false, bookingRef: action.payload };
    case actions.BOOKING_CREATE_FAILURE:
      return { ...state, loading: false, error: action.payload };
   
    case actions.BOOKING_SET_GUEST_INFO:
      return { ...state, guestInfo: action.payload }
    case actions.BOOKING_RESET:
      return { ...initialState }
    
    case actions.GET_BOOKING_STATUS_REQUEST:
      return { ...state, loading: true, error: null, bookingStatus: null };
    case actions.GET_BOOKING_STATUS_SUCCESS:
      return { ...state, loading: false, bookingStatus: action.payload };
    case actions.GET_BOOKING_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload, bookingStatus: null };

    default:
      return state;
  }
}
